"use client";
import { ACCESS_TOKEN, ROLE } from "@/constants/common";
import { useConfigQuery } from "@/hooks/Query/useConfigQuery";
import { useUserQuery } from "@/hooks/Query/useUserQuery";
import { setConfigs, updateUser } from "@/lib/features/authSlice";
import { useAppDispatch } from "@/lib/hooks";
import { ConfigData } from "@/models/config";
import { User } from "@/models/user";
import { setCookieSSR } from "@/utils/auth";
import { useQueryClient } from "@tanstack/react-query";
import { setCookie } from "cookies-next";
import { ReactNode, useEffect, useLayoutEffect } from "react";

export default function AuthProvider({
  userServer,
  config,
  children,
  currency,
}: {
  userServer?: User | null;
  config?: ConfigData | null;
  children: ReactNode;
  currency?: string;
}) {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const { data: user } = useUserQuery({
    user: userServer as User,
    options: {
      enabled: !!userServer,
    },
  });
  const { data: configg } = useConfigQuery({
    config: config as ConfigData,
    currency: currency,
    options: {
      enabled: !!config,
    },
  });

  useLayoutEffect(() => {
    if (user) {
      dispatch(updateUser(user));
      setCookieSSR(ROLE, user?.admin_type || {});
    } else {
      setCookie(ACCESS_TOKEN, null, {
        maxAge: -1,
      });
      setCookie(ROLE, null, {
        maxAge: -1,
        path: "/",
      });
    }
  }, [user, dispatch]);

  useLayoutEffect(() => {
    if (configg) {
      dispatch(setConfigs(configg));
    }
  }, [dispatch, configg]);

  useEffect(() => {
    const toogleThemeAdmin = localStorage.getItem("toolpad-mode");
    if (!toogleThemeAdmin) {
      localStorage.setItem("toolpad-mode", "light");
    }
  }, []);

  return <>{children}</>;
}
